import React, { useCallback, useEffect, useRef, useState, memo } from "react";
import moment from "moment";
import TradingChartComponent from "./index.jsx";
import { useSelector } from "react-redux";
import { PRICE_SCALE_VALUE } from "../../../constants/constants";
import "./TradeChart.scss";
import { parseJSON } from "../../../helpers/commonHelper";
import CardHeading from "../../../components/common/CardHeading/CardHeading.jsx";
const TradeChart = ({
  sectionRef
}) => {
  const rootRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [tradeData, setTradeData] = useState({});
  const selectedPair = useSelector(state => state?.ats?.selectedPair);
  const lastTrade = useSelector(state => state?.ats?.lastTrade);
  const theme = useSelector(state => state?.persist.theme);
  const setTradeChartRootRef = useCallback(node => {
    rootRef.current = node;
    if (typeof sectionRef === "function") {
      sectionRef(node);
    } else if (sectionRef) {
      sectionRef.current = node;
    }
  }, [sectionRef]);
  useEffect(() => {
    const syncFullscreen = () => {
      const el = rootRef.current;
      const active = document.fullscreenElement === el || document.webkitFullscreenElement === el;
      setIsFullscreen(Boolean(active));
      // TradingView (autosize:false) needs a window resize to fill the new container.
      window.setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 80);
    };
    document.addEventListener("fullscreenchange", syncFullscreen);
    document.addEventListener("webkitfullscreenchange", syncFullscreen);
    syncFullscreen();
    return () => {
      document.removeEventListener("fullscreenchange", syncFullscreen);
      document.removeEventListener("webkitfullscreenchange", syncFullscreen);
    };
  }, []);
  useEffect(() => {
    if (lastTrade) {
      const tradeObject = {
        price: Number(lastTrade.price),
        volume: Number(lastTrade.filled_amount),
        time: moment(lastTrade.created_at).unix()
      };
      setTradeData(parseJSON(tradeObject));
    }
  }, [selectedPair, lastTrade]);
  return <div className={`tradeChartRoot${isFullscreen ? " is-fullscreen" : ""}`} ref={setTradeChartRootRef}>
      <div className="tradeChartRoot__panel">
        <CardHeading title="Market Depth" />
        <div className="tradeChartcard">
          {selectedPair ? <TradingChartComponent theme={theme} interval="D" symbol={`${selectedPair?.otherCurrency}/${selectedPair?.baseCurrency}`} selectedPairKey={{
          pair: `${selectedPair?.otherCurrency}/${selectedPair?.baseCurrency}`,
          pair_key: selectedPair?.pair_key.toLowerCase()
        }} kline={tradeData} pricescaleValue={10 ** PRICE_SCALE_VALUE} baseDecimal={PRICE_SCALE_VALUE} priceDecimal={PRICE_SCALE_VALUE} /> : null}
        </div>
      </div>
    </div>;
};
export default memo(TradeChart);